module.exports = __webpack_public_path__ + "media/images/icons/board-5a6f33af88f4fd7f9b4c37455474345e.svg";